import { render, staticRenderFns } from "./GlobalMapInfo.vue?vue&type=template&id=370abec4&scoped=true"
import script from "./GlobalMapInfo.vue?vue&type=script&lang=js"
export * from "./GlobalMapInfo.vue?vue&type=script&lang=js"
import style0 from "./GlobalMapInfo.vue?vue&type=style&index=0&id=370abec4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370abec4",
  null
  
)

export default component.exports